/**
 * The Pinned section's compact age (card 1.4): "now", "12 min", "3 h", "4 d",
 * "2 mo", "1 y" — through `t` so German reads "4 T" etc.
 */
export function shortAge(at, now, t) {
  const s = Math.max(0, Math.round((now - Number(at)) / 1000));
  if (s < 60) return t('docSidebar.age.now');
  const min = Math.floor(s / 60);
  if (min < 60) return t('docSidebar.age.minutes', { count: min });
  const h = Math.floor(min / 60);
  if (h < 24) return t('docSidebar.age.hours', { count: h });
  const d = Math.floor(h / 24);
  if (d < 30) return t('docSidebar.age.days', { count: d });
  if (d < 365) return t('docSidebar.age.months', { count: Math.floor(d / 30) });
  return t('docSidebar.age.years', { count: Math.floor(d / 365) });
}
